import { render, staticRenderFns } from "./SavitarnaPranesimai.vue?vue&type=template&id=21927be2&scoped=true&"
import script from "./SavitarnaPranesimai.vue?vue&type=script&lang=js&"
export * from "./SavitarnaPranesimai.vue?vue&type=script&lang=js&"
import style0 from "./SavitarnaPranesimai.vue?vue&type=style&index=0&id=21927be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21927be2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VContainer,VDataTable})
